import { get, del } from './jsonfetchservice.js';

export default {
    name: 'recentsearchesservice',
    dependencies: [],
    callable() {
        const endpoint = new URL('/user/lastSearches.json', document.baseURI);

        function getRecentSearches(vertical) {
            const url = new URL(endpoint);
            if (vertical) {
                url.searchParams.set('vertical', vertical.toUpperCase());
            }
            return get(url.href);
        }

        function clearRecentSearches() {
            const url = new URL(endpoint);
            return del(url.href);
        }

        return {
            getRecentSearches,
            clearRecentSearches,
        };
    },
};



// WEBPACK FOOTER //
// ./services/recentsearchesservice.js